import { useCallback } from 'react';
import {
  useAccountRoleTracking,
  useCurrentPlanTracking,
} from '@frameio/shared/plans/hooks';
import { useTrackUnsafe } from '@frameio/shared/segment/hooks';
import { useCurrentSubscriptionAddOnsTracking } from '../../plans/hooks';
import { useCurrentAccountLockTracking } from './useCurrentAccountLockTracking';

export function useTrackIntercomOpened() {
  const track = useTrackUnsafe();

  const accountRoleTracking = useAccountRoleTracking();
  const currentPlanTracking = useCurrentPlanTracking();
  const currentSubscriptionAddOnsTracking =
    useCurrentSubscriptionAddOnsTracking();
  const currentAccountLockTracking = useCurrentAccountLockTracking();

  const trackIntercomOpened = useCallback(() => {
    track('support-chat-opened', {
      ...currentPlanTracking,
      ...accountRoleTracking,
      ...currentSubscriptionAddOnsTracking,
      ...currentAccountLockTracking,
    });
  }, [
    accountRoleTracking,
    currentPlanTracking,
    currentSubscriptionAddOnsTracking,
    currentAccountLockTracking,
    track,
  ]);

  return trackIntercomOpened;
}
